//export const API_BASE = 'http://127.0.0.1:8080/api';

export const REMOTE_API_BASE = 'https://infosk.herokuapp.com/api/v1';

export default REMOTE_API_BASE;
